import { Injectable } from '@angular/core';

@Injectable()
export class FormatUtilities {

    constructor() {

    }

    //numbers retrieved by Date.now
    getReadableTimeRange(then: number, now: number): string {
        return (now - then) / 1000 + " seconds";
    }

    /// Formats the UserName to remove the UserID
    formatUsername(username: string): string {
        if (username !== undefined && username !== null) {
            return username.split('-')[1];
        }
        return 'System User';
    }

    /// Formats the basePercent from a Decimal to a Percent value for the UI
    formatPercent(basePercent: number): string {
        let returnValue = '';

        if (basePercent !== undefined && basePercent !== null) {
            let percentString = Number(basePercent * 100).toString();
            if (percentString.indexOf('.') !== -1) {
                if (parseFloat(percentString) - parseFloat(parseFloat(percentString).toFixed(0)) === 0) {
                    returnValue = (parseFloat(percentString).toFixed(0));
                } else {
                    returnValue = (parseFloat(percentString).toFixed(2));
                }
            } else {
                returnValue = (parseFloat(percentString).toString());
            }
            returnValue = returnValue + '%';
            return returnValue
        }
        return returnValue;
    }

    /// Formats the baseCurrency from a Decimal to a currency value for the UI
    formatCurrency(baseCurrency: number): string {
        let returnValue = '';

        if (baseCurrency === 0 || (baseCurrency !== undefined && baseCurrency !== null)) {
            let currencyString = baseCurrency.toString();
            if (currencyString.indexOf('.') !== -1) {
                if (parseFloat(currencyString) - parseFloat(parseFloat(currencyString).toFixed(0)) === 0) {
                    returnValue = (parseFloat(currencyString).toFixed(0));
                } else {
                    returnValue = (parseFloat(currencyString).toFixed(2));
                }
            } else {
                returnValue = (parseFloat(currencyString).toString()) + '.00';
            }
            returnValue = '$' + returnValue;
            return returnValue;
        }
        return returnValue;
    }

    /// Formats the booleanValue to a string for the UI
    formatBoolean(value: boolean): string {
        if (value) {
            return 'Y';
        }
        return 'N';
    }

    /// Formats the Custom Option Numbers to be 6 Digits
    formatOptionNumber(value: number, customOption: boolean): string {
        if (customOption) {
            let prefix: string;
            switch (value.toString().length) {
                case 4:
                    prefix = '00';
                    break;
                case 5:
                    prefix = '0';
                    break;
                default:
                    prefix = '';
            }
            return `${prefix}${value}`.toString();
        } else {
            return value.toString();
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/utilities/format-utilities.ts